import { CostBasisMethodHolding } from '@interfaces/cost-basis/cost-basis.service.interface';
import { createAction, props } from '@ngrx/store';
import { FilteredCostBasisCoveredLot } from '@shared/services';
import { PositionUpdateRequest } from 'src/app/shared/helpers/cost-basis';

import { CostBasisPosition } from '../../reducers/cost-basis/cost-basis.reducer';

export const LoadGiftingCostBasisMethod = createAction(
  '[Cost Basis] Starting Cost Basis Method Call (Gifting)',
);
export const LoadInternalTransferCostBasisMethod = createAction(
  '[Cost Basis] Starting Cost Basis Method Call (Internal Transfer)',
);
export const LoadMultiInternalTransferCostBasisMethod = createAction(
  '[Cost Basis] Starting Cost Basis Method Call (Multi-Receiving Internal Transfer)',
);
export const LoadCostBasisMethodFail = createAction('[Cost Basis] Cost Basis Method Fail');
export const LoadCostBasisMethodSuccess = createAction(
  '[Cost Basis] Cost Basis Method Success',
  props<{ payload: (CostBasisMethodHolding | undefined)[] }>(),
);
export const CostBasisMethodReset = createAction('[Cost Basis] Resetting Cost Basis Method');

export const LoadCostBasisLots = createAction(
  '[Cost Basis] Starting Cost Basis Lots Call',
  props<{ payload: number }>(),
);
export const LoadCostBasisLotsFail = createAction('[Cost Basis] Cost Basis Lots Fail');
export const LoadCostBasisLotsSuccess = createAction(
  '[Cost Basis] Cost Basis Lots Success',
  props<{ payload: FilteredCostBasisCoveredLot[] }>(),
);
export const UpdateSelectedPositions = createAction(
  '[Cost Basis] Update Selected Positions',
  props<{ payload: CostBasisPosition[] }>(),
);
export const UpdateSelectedPositionProperties = createAction(
  '[Cost Basis] Update Selected Position Properties',
  props<{ payload: PositionUpdateRequest }>(),
);

export const GiftingMethodContinue = createAction('[Cost Basis] Gifting Method Continue');

export const internalTransferConvertHoldings = createAction(
  '[Cost Basis] Converting Internal Transfer Avg Cost Holdings',
);
export const internalTransferConvertFailed = createAction(
  '[Cost Basis] Converting cost basis method failed',
);

export const MXMConvertHoldings = createAction(
  '[Cost Basis] MXM Converting Internal Transfer Avg Cost Holdings',
);
